export default{
  ReadProps(action, onsuccess, onfailed, permission_needed, state, props, ordering, self=null){
    return {
        data : {
          query              : state.query,
          AuthorizationToken : props.UserReducer.token,
          ordering           : ordering,
        },
        action            : action,
        Reducer           : props.Reducer,
        UserReducer       : props.UserReducer,
        RunRedux          : props.RunRedux,
        onsuccess         : onsuccess,
        onfailed          : onfailed,
        permission_needed : permission_needed,
        self              : self,
    }
  },
  RegisterUpdateProps(onsuccess,onfailed,permission_needed,state,props,self){
    return {
        data : {
          Alias              : state.Alias,
          Tag                : state.Tag,
          Name               : state.Name,
          Description        : state.Description,
          SerialNumber       : state.SerialNumber,
          PurchasedDate      : state.PurchasedDate,
          PurchaseCurrency   : state.PurchaseCurrency,
          PurchaseOrder      : state.PurchaseOrder,
          PurchaseVendorName : state.PurchaseVendorName,
          Status             : state.Status,
          Type               : state.Type,
          PurchasePrice      : state.PurchasePrice,
          Site               : state.Site,
          Location           : state.Location,
          MaxDay             : state.MaxDay,
          WarrantyPeriod     : state.WarrantyPeriod,
          Make               : state.Make,
          Model              : state.Model,
          AuthorizationToken : props.UserReducer.token,
        },
        UserReducer       : props.UserReducer,
        RunRedux          : props.RunRedux,
        onfailed          : onfailed,
        onsuccess         : onsuccess,
        permission_needed :permission_needed,
        self              :self,
    }
  },
  DeleteProps(onsuccess,onfailed,permission_needed,state,props,self){
    return {
        data : {
          Alias : state.Alias,
          Name : state.Name,
          AuthorizationToken : props.UserReducer.token,
          PurchaseOrder : state.PurchaseOrder,
          PurchasePrice : state.PurchasePrice,
          PurchasedDate : state.PurchasedDate,
          SerialNumber : state.SerialNumber,
          Tag : state.Tag,
        },
        UserReducer: props.UserReducer,
        RunRedux : props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        permission_needed:permission_needed,
        self:self,
    }
  },

}



// WEBPACK FOOTER //
// ./src/App/asset/asset/helper/request_props.js